import React from "react";

export default function WiderTalkHeading({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex items-center text-widertalk-navy text-[20px] font-gendy leading-[20px]">
      <div className="w-1 h-5 bg-widertalk-lime rounded-lg mr-2"></div>
      {children}
    </div>
  );
}
